import { useState, useEffect } from "react";
import { Badge, NavDropdown } from "react-bootstrap";
import { FaBell } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import api from "../../services/api";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import DropdownItemAtendimento from "./NotificationItems/DropdownItemAtendimento";
import DropdownItemChamado from "./NotificationItems/DropdownItemChamado";
import DropdownItemFarmaco from "./NotificationItems/DropdownItemFarmaco";
import DropdownItemFormulario from "./NotificationItems/DropdownItemFormulario";
import DropdownItemExame from "./NotificationItems/DropdownItemExame";
import DropdownItemExameBloqueado from "./NotificationItems/DropdownItemExameBloqueado";

import DropdownItemArquivoAgendamento from "./NotificationItems/DropdownItemArquivoAgendamento";
import DropdownItemAgendamentoRealizado from "./NotificationItems/DropdownItemAgendamentoRealizado";
import DropdownItemAlvara from "./NotificationItems/DropdownItemAlvara";

const NotificacaoBell = () => {
  const { t } = useTranslation(['layout']);
  const [notificacoes, setNotificacoes] = useState([]);
  const [mostrarBadge, setMostrarBadge] = useState(false);
  const [alertShown, setAlertShown] = useState(false);

  const MySwal = withReactContent(Swal);

  useEffect(() => {
    const fetchNotificacoes = async () => {
      try {
        const response = await api.get("/notificacoes/");
        const data = response.data?.results || response.data || [];
        setNotificacoes(Array.isArray(data) ? data : []);

        const temNotif = data.length > 0;
        setMostrarBadge(temNotif);

        const reportesFarmaco = data.filter((n) => !!n?.reporte_info);
        const qtdReportes = reportesFarmaco.length;

        if (qtdReportes > 0 && !alertShown) {
          setAlertShown(true);
          fireAlertaReporte(qtdReportes);
        }
      } catch (error) {
        console.error("Erro ao buscar notificações:", error);
      }
    };

    fetchNotificacoes();
    const interval = setInterval(fetchNotificacoes, 60000); 
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertShown]);

  const fireAlertaReporte = async (quantidade) => {
    let remaining = 5;

    const texto = t('layout:notifications.alert.newReports', { count: quantidade });

    const { dismiss } = await MySwal.fire({
      title: t('layout:notifications.alert.title'),
      icon: "warning",
      html:
        `${texto}<br/><br/>` +
        t('layout:notifications.alert.hint'),
      showCancelButton: true,
      cancelButtonText: t('layout:notifications.alert.viewReports'),
      confirmButtonText: t('layout:notifications.alert.confirm'),
      reverseButtons: true,
      allowOutsideClick: false,
      didOpen: () => {
        const confirmBtn = Swal.getConfirmButton();
        if (confirmBtn) confirmBtn.disabled = true;

        const container = Swal.getHtmlContainer();
        const timerEl = document.createElement("div");
        timerEl.style.marginTop = "8px";
        timerEl.style.fontSize = "0.9rem";
        timerEl.innerHTML = t('layout:notifications.alert.countdown', { seconds: remaining });
        container.appendChild(timerEl);

        const interval = setInterval(() => {
          remaining -= 1;
          if (remaining > 0) {
            timerEl.innerHTML = t('layout:notifications.alert.countdown', { seconds: remaining });
          } else {
            clearInterval(interval);
            if (confirmBtn) confirmBtn.disabled = false;
            timerEl.remove();
          }
        }, 1000);
      },
    });

    if (dismiss === Swal.DismissReason.cancel) {
      window.location.href = "/reportes-farmaco";
    } else {
       try {
        await api.post("/notificacoes/marcar-como-lidas/"); 
        setMostrarBadge(false);
        setNotificacoes([]); 
      } catch (error) { console.error(error); }
    }
  };

  const handleMarcarComoLidas = async () => {
    if (!mostrarBadge) return;
    setMostrarBadge(false);
    try {
      await api.post("/notificacoes/marcar-como-lidas/");
    } catch (error) {
      console.error("Erro ao marcar notificações como lidas:", error);
    }
  };

  const handleNotificationClick = (notif) => {
    if (notif.tipo === 'arquivo_agendamento' && notif.atendimento_info) {
        const identificador = notif.atendimento_info.uuid || notif.atendimento_info.id;
        window.location.href = `/atendimentos/edit/${identificador}/?aba=agendamentos`;
    } else if (notif.tipo === 'agendamento_realizado' && notif.atendimento_info) {
        const identificador = notif.atendimento_info.uuid || notif.atendimento_info.id;
        window.location.href = `/atendimentos/edit/${identificador}/?aba=agendamentos`;
    } else if (notif.reporte_info) {
        window.location.href = `/reportes-farmaco/detalhe/${notif.reporte_info.id}`;
    } else if (notif.chamado_info) {
        window.location.href = `/chamados/edit/${notif.chamado_info.id}`;
    } else if (notif.prestador_info) {
        window.location.href = `/prestadores/edit/${notif.prestador_info.id}`;
    } else if (notif.atendimento_info) {
        const identificador = notif.atendimento_info.uuid || notif.atendimento_info.id;
        if (notif.tipo === 'nova_solicitacao_exame' || notif.tipo === 'tentativa_exame_bloqueada') {
             window.location.href = `/atendimentos/edit/${identificador}/?tab=exames`;
        } else {
             window.location.href = `/atendimentos/edit/${identificador}`;
        }
    }
  };

  const contagem = notificacoes.length;

  return (
    <NavDropdown
      title={
        <>
          <FaBell size={20} />
          {mostrarBadge && contagem > 0 && (
            <Badge
              pill
              bg="danger"
              style={{
                position: "absolute",
                top: "5px",
                right: "5px",
                fontSize: "0.65rem",
              }}
            >
              {contagem}
            </Badge>
          )}
        </>
      }
      id="notificacao-dropdown"
      align="end"
      onToggle={(isOpen) => {
        if (isOpen) handleMarcarComoLidas();
      }}
    >
      <NavDropdown.Header>{t('layout:notifications.title')}</NavDropdown.Header>
      
      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
      {notificacoes.length > 0 ? (
        notificacoes.map((notif) => {
          if (notif.tipo === 'arquivo_agendamento') {
              return <DropdownItemArquivoAgendamento key={notif.id} notif={notif} onClick={() => handleNotificationClick(notif)} />;
          }
          if (notif.tipo === 'agendamento_realizado') {
              return <DropdownItemAgendamentoRealizado key={notif.id} notif={notif} onClick={() => handleNotificationClick(notif)} />;
          }
          if (notif.tipo === 'formulario_dinamico') {
              return <DropdownItemFormulario key={notif.id} notif={notif} onClick={() => handleNotificationClick(notif)} />;
          }
          
          if (notif.tipo === 'nova_solicitacao_exame') {
              return <DropdownItemExame key={notif.id} notif={notif} onClick={() => handleNotificationClick(notif)} />;
          }

          if (notif.tipo === 'tentativa_exame_bloqueada') {
              return <DropdownItemExameBloqueado key={notif.id} notif={notif} onClick={() => handleNotificationClick(notif)} />;
          }

          if (notif.reporte_info) {
              return <DropdownItemFarmaco key={notif.id} notif={notif} onClick={() => handleNotificationClick(notif)} />;
          }

          if (notif.chamado_info) {
             return <DropdownItemChamado key={notif.id} notif={notif} onClick={() => handleNotificationClick(notif)} />;
          }

          if (notif.tipo === 'alvara_vencimento' && notif.prestador_info) {
            return <DropdownItemAlvara key={notif.id} notif={notif} onClick={() => handleNotificationClick(notif)} />;
          }

          if (notif.atendimento_info) {
            return <DropdownItemAtendimento key={notif.id} notif={notif} onClick={() => handleNotificationClick(notif)} />;
          }

          return null;
        })
      ) : (
        <NavDropdown.Item disabled>{t('layout:notifications.empty')}</NavDropdown.Item>
      )}
      </div>
      
    </NavDropdown>
  );
};

export default NotificacaoBell;
